var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDauer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.58 54.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ec6746;\n        stroke-miterlimit: 10;\n        stroke-width: 3.05px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.29,13.26v14.03l8.75,8.75M49.6,40.17c-7.11,12.32-22.87,16.54-35.19,9.43C2.09,42.48-2.13,26.73,4.98,14.41,12.09,2.09,27.85-2.13,40.17,4.98c12.32,7.11,16.54,22.87,9.43,35.19ZM38.31,8.19l-2.01,3.49M46.39,16.26l-3.48,2.01M49.34,27.29h-4.02M46.39,38.31l-3.48-2.01M38.31,46.38l-2.01-3.48M27.29,49.34v-4.02M16.26,46.38l2.01-3.48M8.19,38.31l3.49-2.01M5.24,27.29h4.02M8.19,16.26l3.49,2.01M16.26,8.19l2.01,3.49M27.29,5.24v4.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDauer);
export default __webpack_public_path__ + "static/media/Dauer.723ebd58689170f74542c55837c6ba48.svg";
export { ForwardRef as ReactComponent };